import { UsersDto } from "users-experience-client";
import { ToastConfig } from "../../components/Toaster";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useEffect, useState } from "react";
import Spinner from "../../components/Spinner";
import { string, z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

import { createLocationApi } from "../../api-helpers/CommonUtilsApiHelper";
import { IdValuePairDTO } from "common-util-experience-client";

import React from 'react';
import { Dropdown, Badge, Form, CloseButton } from 'react-bootstrap';

// Data Needed -
// Timezone ddl
// Roles ddl
// Ability to save partner info

const userFormSchema = z.object({
    userId: z.string(),
    firstName: z.string().min(1, { message: "First name is required" }),
    lastName: z.string().min(1, { message: "Last name is required" }),
    roleType: z.string().min(1, { message: "Role type is required" }),
    licensedStates: z.array(z.string()).optional(),
    timezone: z.string().min(1, { message: "Timezone is required" }),
});

type UserForm = z.infer<typeof userFormSchema>;

type AddUpdateUserProps = {
  user?: UsersDto;
  onSubmitUser: (toasterConfig: ToastConfig) => void;
  setOffCanvasShow: (data: any) => void;
};

const AddUpdateUser: React.FC<AddUpdateUserProps> = (props: AddUpdateUserProps) => {
    const locationAPI = createLocationApi();

    const [initialized, setInitialized] = useState(false);
    const [loading, setLoading] = useState(true);
    const [validated, setValidated] = useState(false);

    const [timeZoneCollection, setTimeZoneCollection] = useState<IdValuePairDTO[]>([]);
    const [stateCollection, setStateCollection] =  useState<IdValuePairDTO[]>([]);

    const { register, handleSubmit, control, setValue, watch, formState: { errors, isSubmitted } } = useForm<UserForm>(
        {
            defaultValues: {
                userId: props.user?.id,
                firstName: props.user?.firstName,
                lastName: props.user?.lastName,
                roleType: 'admin',
                // licenseState: props.user?.licenseState,
                // appointmentType: props.user?.appointmentType,
                timezone: props.user?.timezone
            },
            resolver: zodResolver(userFormSchema),
        }
    );

    const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    // timezones
    useEffect(() => {
        const getTimeZones = async () => {
          // await delay(2000);
            setLoading(false);
            // try {
            //     const response = (await locationAPI.locationControllerGetAllTimezones()).data;
            //     if (response) {
            //         setTimeZoneCollection(response);
            //     }

            //     await delay(2000)
            // }
            // catch (error) {
            //     console.log("Error in getting timezone: ", error);
            // }
            // finally {
            //     setLoading(false);
            // }
        }
        getTimeZones();
    }, []);

    useEffect(() => {
        const getStates = async () => {
            try {
                const response = (await locationAPI.locationControllerFindAllStates()).data;
                if (response) {
                    setStateCollection(response);
                }
            } catch(error) {

            }
            finally {

            }
        };

        getStates();
    }, []);

    // roles
    useEffect(() => {
       
    }, []);


    const onSubmit: SubmitHandler<UserForm> = data => { 
        setLoading(true);

        try {
            console.log('saving user')
        }
        catch (error) {
            console.log("Error in updating user: ", error);
        }
        finally {
            setLoading(false);
            props.setOffCanvasShow(false);
        }
        // try {
        //       if (isUpdate) {
        //         await taskApi.taskControllerUpdate(updateTaskForm, taskId as string);
        //       } else {
        //         let newAddtaskForm=addTaskForm;
        //         if(appointmentId){
        
        //            newAddtaskForm  = { ...addTaskForm,
        //           sourceAppointmentId:appointmentId};
        //         }
        //         await taskApi.taskControllerCreate(newAddtaskForm);
        //       }
        //       const toasterConfig = {
        //         type: "success",
        //         title: isUpdate ? "Task updated successfully!" : "Task added successfully!",
        //         icon: "check_circle_outline",
        //       };
        //       onSubmitTask(toasterConfig as ToastConfig);
        //       setTimeout(() => {
        //         handleDiscard();
        //       }, 1000);
        //       reloadGrid && reloadGrid();
        //     } catch (error) {
        //       const toasterConfig = {
        //         type: "danger",
        //         title: isUpdate ? "Error in updating task!!" : "Error in adding task!",
        //         icon: "error_outline",
        //       };
        //       onSubmitTask(toasterConfig as ToastConfig);
        //     } finally {
        //       setLoading(false);
        //     }
    }

    if (loading) {
        return <Spinner />;
    }

    return (
        <>
            {loading && <Spinner />}
            <form className="d-flex flex-column h-100" noValidate onSubmit={handleSubmit(onSubmit)} >
                <div className="row g-2 mt-1">
                    <div className="col-6 mb-2">
                        <label htmlFor="firstName" className="form-label fs-12 fw-semibold mb-1">
                            First Name
                        </label>
                        <input type="text" {...register("firstName") }  className={`form-control form-control-sm ${isSubmitted && (errors.firstName ? "is-invalid" : "is-valid")}`} placeholder="First Name" />
                        {errors.firstName && <div className="invalid-feedback">{errors.firstName.message}</div>}
                    </div>
                    <div className="col-6 mb-2">
                        <label htmlFor="lastName" className="form-label fs-12 fw-semibold mb-1">
                            Last Name
                        </label>
                        <input type="text" {...register("lastName") } className={`form-control form-control-sm ${isSubmitted && (errors.lastName ? "is-invalid" : "is-valid")}`} placeholder="Last Name" />
                        {errors.lastName && <div className="invalid-feedback">{errors.lastName.message}</div>}
                    </div>
                </div>
                <div className="row g-2 mt-1">
                    <div className="col-6 mb-2">
                        <label htmlFor="emailId" className="form-label fs-12 fw-semibold mb-1">
                            Email
                        </label>
                        <input type="text" value={props.user?.email} className={`form-control form-control-sm`} placeholder="Email" disabled />
                    </div>
                    <div className="col-6 mb-2">
                        <label htmlFor="roleType" className="form-label fs-12 fw-semibold mb-1">
                            Role Type
                        </label>
                        <select {...register("roleType") } className={`form-select form-select-sm ${isSubmitted && (errors.roleType ? "is-invalid" : "is-valid")}`} aria-label="Default select example">
                            <option value="">Select Role Type</option>
                            <option value="admin">Admin</option>
                            <option value="user">User</option>
                            <option value="superAdmin">Super Admin</option>
                            <option value="superUser">Super User</option>
                        </select>
                        {errors.roleType && <div className="invalid-feedback">{errors.roleType.message}</div>}
                    </div>
                </div>
                <div className="row g-2 mt-1">
                    <div className="col-6 mb-2">
                        <label htmlFor="licenseState" className="form-label fs-12 fw-semibold mb-1">
                            License State(s)
                        </label>
                        <Controller
                            name='licensedStates'
                            control={control}
                            render={({ field }) => (
                                <MultiSelectDropdown
                                options={stateCollection.map((state) => ({ id: state.value, name: state.value }))}
                                selectedItems={[ {id: 'Texas', name: 'Texas'}]}
                                placeholder="Select options..."
                                onChange={field.onChange}
                                />
                            )}
                            />
                    </div>
                    <div className="col-6 mb-2">
                        <label htmlFor="appointmentType" className="form-label fs-12 fw-semibold mb-1">
                            Appointment Type(s)
                        </label>
                        <select {...register("timezone")} className={`form-select form-select-sm ${isSubmitted && (errors.timezone ? "is-invalid" : "is-valid")}`} aria-label="Default select example">
                            <option value="">Select Appointment Types</option>
                            {timeZoneCollection.map((tz) => (
                                <option key={tz.id} value={tz.id}>{tz.id}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="row g-2 mt-1">
                    <div className="col-9 mb-2">
                        <label htmlFor="timeZone" className="form-label fs-12 fw-semibold mb-1">
                            Timezone
                        </label>
                        <select {...register("timezone")} className={`form-select form-select-sm ${isSubmitted && (errors.timezone ? "is-invalid" : "is-valid")}`} aria-label="Default select example">
                            <option value="">Select Timezone</option>
                            {timeZoneCollection.map((tz) => (
                                <option key={tz.id} value={tz.id}>{tz.id}</option>
                            ))}
                        </select>

                        {/* <input type="text" {...register("timezone") } className={`form-control form-control-sm ${isSubmitted && (errors.timezone ? "is-invalid" : "is-valid")}`} placeholder="Timezone" /> */}
                        {errors.timezone && <div className="invalid-feedback">{errors.timezone.message}</div>}
                    </div>
                </div>
                <div className="offcanvas-footer w-100 border-top d-flex justify-content-between border-top ">
                    <div>
                        <button
                            className="btn btn-outline-secondary rounded-pill px-5 fs-13"
                            type="reset"
                            onClick={() => props.setOffCanvasShow(false)}
                        >
                        Discard
                        </button>
                    </div>
                    <div className="d-flex gap-2">
                        <button className="btn btn-secondary rounded-pill px-5 fs-13" type="submit">
                            Add
                        </button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default AddUpdateUser;



interface MultiSelectDropdownProps {
  options: { id: string; name: string }[];
  selectedItems: { id: string; name: string }[];
  placeholder: string;
  onChange: (selectedItems: { id: string; name: string }[]) => void;
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
  options,
  selectedItems,
  placeholder,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  
  const handleSelect = (option: { id: string; name: string }) => {
    // Check if item is already selected
    const isSelected = selectedItems.some(item => item.id === option.id);
    
    if (isSelected) {
      // Remove item if already selected
      onChange(selectedItems.filter(item => item.id !== option.id));
    } else {
      // Add item if not already selected
      onChange([...selectedItems, option]);
    }
  };
  
  const handleRemoveItem = (id: string) => {
    onChange(selectedItems.filter(item => item.id !== id));
  };
  
  return (
    <div className="position-relative">
      <Dropdown show={isOpen} onToggle={handleToggle}>
        <Dropdown.Toggle 
          variant="light" 
          className="w-100 text-start d-flex align-items-center border"
        >
          {selectedItems.length === 0 ? (
            <span className="text-muted">{placeholder}</span>
          ) : (
            <div className="d-flex flex-wrap gap-1 flex-grow-1">
              {selectedItems.map(item => (
                <Badge 
                  key={item.id} 
                  bg="secondary" 
                  className="d-flex align-items-center py-1 px-2 me-1 mb-1"
                >
                  {item.name}
                  <CloseButton 
                    variant="white" 
                    // size="sm" 
                    className="ms-1"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveItem(item.id);
                    }}
                  />
                </Badge>
              ))}
            </div>
          )}
        </Dropdown.Toggle>
        
        <Dropdown.Menu className="w-100">
          {options.length > 0 ? (
            options.map(option => (
              <div key={option.id} className="px-2">
                <Form.Check
                  type="checkbox"
                  id={`option-${option.id}`}
                  label={option.name}
                  checked={selectedItems.some(item => item.id === option.id)}
                  onChange={() => handleSelect(option)}
                  className="py-1"
                />
              </div>
            ))
          ) : (
            <Dropdown.Item disabled>No options available</Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};